import { redirectWithPermissionCheck } from "@/router/index";
import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import Bookings from "@/views/bookings/BookingList";
import BookingTabs from "@/views/bookings/BookingTabs";
import BookingDetails from "@/views/bookings/BookingDetails/BookingDetails";
import Candidates from "@/views/bookings/BookingDetails/components/Candidates";
import BookingInterviews from "@/views/bookings/BookingInterviews/BookingInterviews";
import InterviewDetails from "@/views/interviews/InterviewDetails.vue";
import Offers from "@/views/bookings/Offers/JobOffers";
import BookingConversations from "@/views/conversations/Conversations";
import ConversationDetails from "@/views/conversations/ConversationDetails/ConversationDetails.vue";

const { BOOKINGS } = MAIN_NAVIGATION_ITEMS;

export const bookingsRouter = [
  {
    path: "/jobs",
    name: BOOKINGS,
    component: Bookings,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, BOOKINGS);
    }
  },
  {
    path: "/jobs/:id",
    name: "bookingTabs",
    redirect: "/jobs/:id/details",
    component: BookingTabs,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, BOOKINGS);
    },
    children: [
      {
        path: "details",
        name: "bookingDetails",
        component: BookingDetails,
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, BOOKINGS);
        }
      },
      {
        path: "candidates",
        name: "bookingCandidates",
        component: Candidates,
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, BOOKINGS);
        }
      },
      {
        path: "interviews",
        name: "bookingInterviews",
        component: BookingInterviews,
        // temporary permission
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, BOOKINGS);
        }
      },
      {
        path: "interviews/:interviewId",
        name: "bookingInterviewDetails",
        component: InterviewDetails,
        // temporary permission
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, BOOKINGS);
        }
      },
      {
        path: "offers",
        name: "bookingOffers",
        component: Offers,
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, BOOKINGS);
        }
      },
      {
        path: "conversations",
        name: "bookingConversations",
        component: BookingConversations,
        props: { isBookingConversation: true },
        // temporary permission
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, BOOKINGS);
        }
      },
      {
        path: "conversations/:conversationId",
        name: "bookingConversationDetails",
        component: ConversationDetails,
        props: { isBookingConversation: true },
        // temporary permission
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, BOOKINGS);
        }
      }
    ]
  }
];
